import { EdgesPage } from '@elentari/core/types'
import { makeRepository } from '@elentari/core/utils/makeRepository'
import { ParsedQs } from 'qs'
import { apiSauceInstance } from '../../../services/api'
import { paginationParams } from '../../../utils/paginationQueryParams'
import { paraDiaCivil } from '../utils/vigencia'
import {
  AlterarSituacaoData,
  Cenario,
  CenarioDetail,
  CenarioMetadataResponse
} from '../types'

const mapQueryParams = (params: ParsedQs): ParsedQs => {
  const { limit, vigenteEm, ...rest } = params

  return {
    ...paginationParams(rest),
    limit: limit || '10',
    // Dia civil (yyyy-MM-dd): o seletor mantém a hora corrente e o fuso deslocaria o dia na API.
    ...(vigenteEm && { vigenteEm: paraDiaCivil(String(vigenteEm)) })
  }
}

export const cenariosRepository = makeRepository<
  EdgesPage<CenarioDetail>,
  Cenario,
  CenarioDetail,
  string
>({ resource: 'cenarios', mapQueryParams }, apiSauceInstance)

export const alterarSituacao = async (
  id: string,
  data: AlterarSituacaoData
) => {
  return apiSauceInstance.patch<CenarioDetail, { message: string; error: any }>(
    `/cenarios/${id}/alterar-situacao/`,
    data
  )
}

// `cenariosRepository.save` (genérico) decide PUT x POST olhando `data.id`, mas o backend rejeita
// `id` no corpo (DTO sem esse campo + forbidNonWhitelisted). Por isso o update é explícito aqui,
// com o id só na URL — sem depender do `save` genérico.
export const updateCenario = async (id: string, data: unknown) => {
  return apiSauceInstance.put<CenarioDetail, { message: string; error: any }>(
    `/cenarios/${id}`,
    data
  )
}

export const fetchCenarioMetadata = async () => {
  return apiSauceInstance.get<CenarioMetadataResponse>('/cenarios/metadata')
}
